import { render, staticRenderFns } from "./rwpenghargaan.vue?vue&type=template&id=21268b54"
import script from "./rwpenghargaan.vue?vue&type=script&lang=js"
export * from "./rwpenghargaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports